import Repository from "./Repository";

const homeworks = "/homeworks";

export default {
  getHomework: (id) => Repository.get(`${homeworks}/${id}/`),
  getHomeworkStudentTestForTeacher: (id, payload) =>
    Repository.post(`${homeworks}/${id}/student_test/`, payload),
  getHomeworkForTeacher: (id) =>
    Repository.get(`${homeworks}/${id}/homework_for_teacher/`),
  getTeacherHomeworks: (payload) =>
    Repository.get(`${homeworks}/`, {
      params: payload,
    }),
  createHomework: (payload) => Repository.post(`${homeworks}/`, payload),
  saveHomeworkState: (id, payload) =>
    Repository.put(`${homeworks}/${id}/save_state/`, payload),
  saveCurrentExercise: (id, payload) =>
    Repository.patch(`${homeworks}/${id}/save_current_exercise/`, payload),
  completeHomework: (id, payload) =>
    Repository.put(`${homeworks}/${id}/complete/`, payload),
  updateStatus: (id, payload) =>
    Repository.post(`${homeworks}/${id}/update_status/`, payload),
  listStudentHomeworks: (payload) =>
    Repository.get(`${homeworks}/list_student_homeworks/`, {
      params: payload,
    }),
  deleteHomework: (id) => Repository.delete(`${homeworks}/${id}/delete/`),
  updateHomework: (id, payload) =>
    Repository.put(`${homeworks}/${id}/update_homework/`, payload),
  completeUnfinishedClassHomeworks: (payload) =>
    Repository.put(
      `${homeworks}/complete_unfinished_class_homeworks/`,
      payload,
    ),
};
